import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ROUTE_LOGIN, ROUTE_HOME } from '../../../../constants/Routes';
import LinkSuccess from './LinkSuccess';

export default class LinkSuccessContainer extends Component {
	state = { loading: false };

	static propTypes = {
		history: PropTypes.object.isRequired,
		location: PropTypes.object.isRequired,
	};

	componentDidMount() {
		if (!_.get(this.props.location, 'state.loginProvider')) {
			this.props.history.push(ROUTE_LOGIN);
		}
	}

	handleClick = () => {
		this.setState({ loading: true });
		this.props.history.push(ROUTE_HOME);
	};

	render() {
		const loginProvider = _.get(this.props.location, 'state.loginProvider');
		return (
			<LinkSuccess
				onClick={this.handleClick}
				loading={this.state.loading}
				provider={loginProvider}
			/>
		);
	}
}
